import { render, staticRenderFns } from "./OnvegoGreeting.vue?vue&type=template&id=3a82b6bd&scoped=true"
import script from "./OnvegoGreeting.vue?vue&type=script&lang=js"
export * from "./OnvegoGreeting.vue?vue&type=script&lang=js"
import style0 from "./OnvegoGreeting.vue?vue&type=style&index=0&id=3a82b6bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a82b6bd",
  null
  
)

export default component.exports